import { useEffect, useRef, useState } from 'react';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { createPortal } from 'react-dom';
import MessageModal from '../MessageModal';
import type { IModalMessage } from '../MessageModal/IModalMessage';
import { getMessages$, removeModalMsg, resetMessages$ } from '../../lib/modalMessages';
import { usePortalTarget } from '../../provider/UiContext';
import { UiProvider } from '../../provider/UiProvider';
import { useAppPortalHostTarget } from '../../provider/appPortalHost';

// ----Компонент--------------------------------------------------------------------------------------------------------

const ModalMessages = () => {
    const portalTarget = usePortalTarget();
    // окна сообщений — одни на приложение: пока открыта область со своей темой (useAppPortalHost), они в её хосте
    // порталов и в её теме, поверх её окон
    const appHost = useAppPortalHostTarget();
    const host = appHost ?? portalTarget;
    /** Флаг по которому остановить подписку */
    const obstacle = useRef<Subject<boolean>>(new Subject());

    const [sub, setSub] = useState<BehaviorSubject<IModalMessage[]> | null>(null);

    useEffect(() => {
        resetMessages$();

        const sub = getMessages$();

        setSub(sub);
    }, []);

    /** Список уведомлений */
    const [messages, setMessages] = useState<IModalMessage[]>([]);

    // -------------------------------------------------------------------------------------------------------------------

    /** Подписываемся на список уведомлений */
    useEffect(() => {
        if (!sub || sub.closed) {
            return;
        }

        const until = obstacle.current;

        sub.pipe(takeUntil(until)).subscribe((data: IModalMessage[]) => {
            setMessages(data);
        });

        return () => {
            until.next(true);
        };
    }, [sub]);

    // -------------------------------------------------------------------------------------------------------------------
    /** Список уведомлений TSX */
    const list = messages.map((n: IModalMessage, i: number) => (
        <MessageModal key={n.id || i} item={n} remove={removeModalMsg} />
    ));

    // -------------------------------------------------------------------------------------------------------------------

    if (!list.length) {
        return null;
    }

    return createPortal(
        <UiProvider portalTarget={host}>
            <div>{list}</div>
        </UiProvider>,
        host ?? document.body,
    );
};

export default ModalMessages;
